<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Cadastros de pacientes do sistema antigo</b>
						</h3>
					</div>
					<div class="box-body">
						<form action="" @submit.prevent="getDataTable()">
							<div class="row">
								<div class="col-md-6">
									<div class="form-group">
										<label for="">Nome do paciente</label>
										<input v-model="filtros.nm_pessoa" class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-6">
									<div class="form-group">
										<label for="">Nome da mãe</label>
										<input v-model="filtros.nm_mae" class="form-control" type="text">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-2">
									<div class="form-group">
										<label for="">Data de nascimento</label>
										<input v-model="filtros.dt_nascimento" class="form-control" type="date">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label for="">RG</label>
										<input v-model="filtros.nr_rg" class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label for="">CNS</label>
										<input v-model="filtros.nr_cartao_sus" class="form-control" type="text">
									</div>
								</div>
								<div class="col-md-2">
									<div class="form-group">
										<label for="">&nbsp;</label>
										<button class="btn btn-block btn-default"><span class="fa fa-filter"></span> Buscar</button>
									</div>
								</div>
							</div>
						</form>
						<div class="table-responsive">
							<table v-if="dataTable.data" class="table table-striped table-bordered">
								<thead>
									<tr>
										<th>CNS</th>
										<th>Nome</th>
										<th>RG</th>
										<th>Data de nascimento</th>
										<th>Idade</th>
										<th>Nome da mãe</th>
										<th>Ação</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in dataTable.data" :key="index">
										<td>{{item.nr_cartao_sus}}</td>
										<td>{{item.nm_pessoa}}</td>
										<td>{{item.nr_rg}}</td>
										<td>{{item.dt_nascimento | dataFormatada}}</td>
										<td>{{item.dt_nascimento | idade}}</td>
										<td>{{item.nm_mae}}</td>
										<td width="10%">
											<router-link tag="a" target="_blank" :to="'/integracao/pacientes/visualizar/' + item.cd_pessoa" title="Visualizar detalhes" class="btn btn-sm btn-warning"><span class="fa fa-eye"></span></router-link>
											<router-link tag="a" target="_blank" :to="'/integracao/pacientes/historico/' + item.cd_pessoa" title="Visualizar histórico do paciente" class="btn btn-sm btn-success"><span class="fa fa-history"></span></router-link>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="row">
							<div class='col-sm-5'>
								Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.
							</div>
							<div class='col-sm-7' style="text-align:right">
								<laravue-pagination :limit="7" :data="dataTable" v-on:pagination-change-page="getDataTable">
									<span slot="prev-nav">&lt; Anterior</span>
									<span slot="next-nav">Próximo &gt;</span>
								</laravue-pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from 'axios' // Cliente para requisição http
	export default {
		components: {

		},
		filters: {

		},
		data: () => ({
			filtros: {
				nm_pessoa: '',
				nm_mae: '',
				dt_nascimento: '',
				nr_rg: '',
				nr_cartao_sus: '',
			},
			dataTable: {},
		}),
		mounted() {
			// this.getDataTable();
		},
		methods: {
			getDataTable(page) {
				this.$swal({
					title: "Buscando, aguarde...",
					imageUrl: "/static/img/Rolling-green.gif",
					showConfirmButton: false,
					allowOutsideClick: false
				});
				if (typeof page === 'undefined') {
					page = 1;
				}
				this.filtros.page = page;
				this.$store.commit('TOGGLE_LOADING');
				let config = this.$store.getters.getHeaderAuth;
				config.params = this.filtros;

				axios.get(`${this.$store.state.serverURI}/api/integracao/pacientes/getAllPaginate`, config)
					.then(response => {
						this.dataTable = response.data;
						this.$store.commit('TOGGLE_LOADING');
					}).catch((error) => {
						console.log(error);
					}).finally(() => {
						this.$swal.close();
					});
			},
		},
		watch: {

		},
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// index.vue?3c747a9b